import React, { Component } from 'react';
import { Button, Table, Segment, Header, Form, List, Dimmer, Loader }
	from 'semantic-ui-react'
//import Search from '../components/search';
import appstore from '../store/apprdoc-store';
import {observer} from 'mobx-react';
import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import ReactTable from "react-table";
import * as mobx from 'mobx';
import eb from '../utils/EventBus'

class ApproveDoc extends Component {

  constructor(props) {
  	super(props);
  	this.state = {
		  		    visible: false,
					selectedIds: {}
		         }
  }

  componentDidMount() {
  	appstore.loadApprDocs();
  	eb.on('Review Acknowledgment saved', () => this.props.history.push('/approvedoc'));
   }

  toggleVisibility = () => this.setState({ visible: !this.state.visible })

  handleChange = (e, { value }) => this.setState({ value })

  setApprvd = (docid) => {
		this.state.selectedIds[docid] = Boolean(!this.state.selectedIds[docid]);
		//console.log(this.state.selectedIds);
  }

  renderReactTable() {
		const docs = mobx.toJS(appstore.filteredDocs);

		return(
				<ReactTable
					data={docs}
					noDataText="No records found"
					 //filterable
         			 //defaultFilterMethod={(filter, row) =>
           			 //String(row[filter.id]) === filter.value}
					columns = {[
						{ Header: "Document Name", accessor: "docname", Cell: props => {
							const { original } = props;
							return (<Link to={"/apprdocdetail/" + original.docid}>{original.docname}</Link>)
						}
						},
						{ Header: "Description", accessor: "docdescr" },
						{ Header: "Tags", accessor: "tag" },
						{ Header: "Creation Date", accessor: "creationdate" },
						{ Header: "Created By", accessor: "createdby" },
						{ Header: "Approve", accessor: " ",
			              Cell: ({ original }) => {
			                return (
			                  <input
			                    type="checkbox"
			                    className="checkbox"
			                    onChange={() => this.setApprvd(original.docid)}
			                  />
			                );
			              }
			            },
					]}
					style={{
						height: '80vh'
					}}
					defaultPageSize={25}
					//className="-striped -highlight"
					showPaginationTop={true}
					showPaginationBottom={false}
				/>

		)

	}


  render() {
        return(
	            <div className="user-actions">

	                <div className="title">
	                   <h4 align="left">Approve Document</h4>
	                </div>

	                <div className="buyer-actions">
						<div className="flex">
						    <Button inverted primary><Link to="/apprvdlist">Approved Doc List</Link></Button>

						</div>

						<div className="releaseForFactorBtn">
							<Button primary onClick={() => appstore.updApprFlag(this.state.selectedIds)}>Approve</Button>
						</div>
    				</div>

            		 {appstore.loading && (
				          <Segment>
				            <Dimmer active inverted>
				              <Loader inverted>Loading</Loader>
				            </Dimmer>
				          </Segment>
				      )}

					 {this.renderReactTable()}

	            </div>
              )
  }
}

export default observer(ApproveDoc);



// WEBPACK FOOTER //
// ./src/containers/ApproveDoc.js